import { createSlice } from "@reduxjs/toolkit";
import { KEY_SAVE_CART_ITEMS } from "config";

const cartSlice = createSlice({
  name: "cartItems",
  initialState: {
    items: [],
    totalQuantity: 0,
    totalAmount: 0,
    isLoading: false,
    hasError: false,
    isSended: false,
  },
  reducers: {
    replaceCart(state, action) {
      state.items = action.payload.items;
    },
    saveItemsTemporaly(state) {
      localStorage.setItem(KEY_SAVE_CART_ITEMS, JSON.stringify(state.items));
    },
    removeItems(state) {
      state.items = [];
      state.totalQuantity = 0;
      localStorage.removeItem(KEY_SAVE_CART_ITEMS);
    },

    addItemToCart(state) {
      state.totalQuantity++;
    },
    setTotalAmount(state, action) {
      state.totalAmount = action.payload;
    },
    setTotalQuantity(state, action) {
      state.totalQuantity = action.payload;
    },
    removeItemToCart(state) {
      state.totalQuantity--;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setHasError(state, action) {
      state.hasError = action.payload;
    },
    setIsSended(state, action) {
      state.isSended = action.payload;
    },
  },
});

export const cartActions = cartSlice.actions;
export default cartSlice;
